import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import api from '../utils/axiosConfig';
import { useAuth } from './AuthContext';

const SetupContext = createContext(null);

export function SetupProvider({ children }) {
  const { isAuthenticated, isSuperAdmin, account } = useAuth();
  // null = not checked yet, true/false = whether at least one reservation type exists
  const [hasTypes, setHasTypes] = useState(null);
  const [checking, setChecking] = useState(true);

  const refresh = useCallback(async () => {
    // Super admins and guests are never gated by the reservation-type setup.
    if (!isAuthenticated || isSuperAdmin) {
      setHasTypes(true);
      setChecking(false);
      return;
    }
    setChecking(true);
    try {
      const { data } = await api.get('/backoffice/reservation-types');
      if (data.success) {
        setHasTypes((data.reservation_types || []).length > 0);
      } else {
        setHasTypes(true); // fail open so a transient error never locks the admin out
      }
    } catch {
      setHasTypes(true); // fail open
    } finally {
      setChecking(false);
    }
  }, [isAuthenticated, isSuperAdmin]);

  // Re-check on mount and whenever the logged-in account changes
  // (e.g. superadmin switches into an account).
  useEffect(() => {
    refresh();
  }, [refresh, account?.id]);

  return (
    <SetupContext.Provider value={{ hasTypes, checking, refresh, setHasTypes }}>
      {children}
    </SetupContext.Provider>
  );
}

export function useSetup() {
  return useContext(SetupContext);
}
